<div class="modal-header">
    <h5 class="modal-title">
        <ng-container *ngIf="plan?.sub !== '/m' && plan.type !== 'package'">
            Передплата на місяць + AI асистент
        </ng-container>
        <ng-container *ngIf="plan?.sub === '/m' && plan.type !== 'package'">
            Передплата на рік + AI асистент
        </ng-container>
        <ng-container *ngIf="plan.type === 'package'">
            Пакет: 12 сеансів +  AI асистент
        </ng-container>

    </h5>
    <button
            type="button"
            class="close"
            (click)="onClose()">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 1.00024L1 17.0002M1 1.00024L17 17.0002" stroke="#10082F" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </button>
</div>
<div class="modal-body position-relative">
    <ng-container *ngIf="plan?.sub === '/m' && plan.type !== 'package'">
        <div *ngIf="!isUpdate">
            <p class="mb-2">
                Зробіть передплату на свідомий стиль життя! Отримайте персоніфіковану статистику, особистий моніторинг
                та фахові поради від нашого AI асистента, який спеціально навчений на актуальній психологічній
                літературі та розуміє ваш стан відповідно до даних тестів Anima.
            </p>
            <p class="mb-2">
                Увага! AI асистент не є заміною терапевта чи психіатра та може робити помилки. Проконсультуйтеся зі
                спеціалістом у разі потреби.
            </p>
            <p>
                Ви зможете у будь-який момент скасувати передплату.
            </p>
        </div>
        <div *ngIf="isUpdate">
            <p class="mb-2">
                Ви переходите на новий тариф “Передплата на місяць + АІ асистент”. Оплата за ваш новий тариф зніметься з
                початком нового місяця, проте доступ до АІ асистента ви отримаєте негайно.
            </p>
            <p class="mb-2">
                Ви отримаєте персоніфіковану статистику, особистий моніторинг та фахові поради від нашого AI асистента,
                який спеціально навчений на актуальній психологічній літературі та розуміє ваш стан відповідно до даних
                тестів Anima.
            </p>
            <p class="mb-2">
                Увага! AI асистент не є заміною терапевта чи психіатра та може робити помилки. Проконсультуйтеся зі
                спеціалістом у разі потреби.
            </p>
            <p class="mb-2">
                Ви зможете у будь-який момент скасувати передплату.
            </p>
        </div>

    </ng-container>
    <ng-container *ngIf="plan?.sub !== '/m' && plan.type !== 'package'">
        <p>
            Зробіть передплату на свідомий стиль життя! Отримайте персоніфіковану статистику, особистий моніторинг та
            фахові поради від нашого AI асистента, який спеціально навчений на актуальній психологічній літературі та
            розуміє ваш стан відповідно до даних тестів Anima.
        </p>
        <p>
            Увага! AI асистент не є заміною терапевта чи психіатра та може робити помилки. Проконсультуйтеся зі
            спеціалістом у разі потреби.
        </p>
        <p>
            Ви зможете у будь-який момент скасувати передплату.
        </p>
    </ng-container>
    <ng-container *ngIf="plan.type === 'package'">
        <p>
            Отримайте персоніфіковану статистику, особистий моніторинг та фахові поради від нашого AI асистента, який спеціально навчений на актуальній психологічній літературі та розуміє ваш стан відповідно до даних тестів Anima.
        </p>
        <p>
            Увага! AI асистент не є заміною терапевта чи психіатра та може робити помилки. Проконсультуйтеся зі спеціалістом у разі потреби.
        </p>
    </ng-container>
    <form [formGroup]="form" class="mt-3 mb-3" (ngSubmit)="applyPromo()">
        <label *ngIf="codeApplyed">Застосовано промокод</label>
        <label *ngIf="!codeApplyed">Ввести промокод</label>
        <div class="input-group ">
            <input [disabled]="loading" [formControlName]="'promoCode'" class="form-control" type="text"
                   placeholder="0000"/>
            <div *ngIf="loading" class="input-group-append">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <small class="text-danger" *ngIf="!loading && error">
                {{error}}
            </small>
            <small class="applyedIcon" *ngIf="!loading && !error && codeApplyed">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-percent"
                     viewBox="0 0 16 16">
                    <path d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0M4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
                </svg>
            </small>
        </div>
        <div class="d-flex justify-content-end">
            <button *ngIf="!codeApplyed" type="submit" class="btn btn-secondary" [disabled]="!form.valid || loading"
                    (click)="applyPromo()">
                Застосувати промо код
                <app-i-arrow></app-i-arrow>
            </button>
        </div>

    </form>
</div>
<div class="modal-footer flex-column">
    <button type="button" class="btn  d-flex justify-content-between" (click)="submit()">
        <span *ngIf="!isUpdate">Перейти до оплати</span>
        <span *ngIf="isUpdate">Перейти на новий тариф</span>
        <span>
            <span [ngClass]="{'prevValue': discountValue}">{{plan.value}}</span>
            <span *ngIf="discountValue">&nbsp;{{discountValue}}</span>
            ₴
            <span *ngIf="plan.type !== 'package'">/міс</span>

        </span>
    </button>
</div>
